export default __webpack_public_path__ + "media/images/banners/bnr_fukushima-c9f5b2fb3e7bb46d1605ed53ce5a4d91.png";